import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Ortak } from './../../../providers/ortak';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { DateTime } from 'ionic-angular/components/datetime/datetime';

/**
 * Generated class for the CariTahsilatPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-cari-tahsilat',
  templateUrl: 'cari-tahsilat.html',
})
export class CariTahsilatPage {
  cari: any = { ID: -1, Definition_: "", CariKartID: "", };
  KasaHareket = { ID: -1, KasaID:1, IslemTuru: 4, Sign: 1,CardRef: 1, Tutar: "", SlsMan: "", Text: "Mobilden yapılan tahsilat",AciklamaRef:1 };
  CariHareket = { ID: -1, CariKartID: "", IslemTuru: 4, Sign: 0, Tutar: "", SlsMan: "", Text: "Mobilden yapılan tahsilat",}
  vwCari: any = {};
  gelencari:any={};
  kasaListesi=[];
  aranan="";
  skip:number=0;
  take:number=50;
  aktifKullanici:any;
  constructor(public navCtrl: NavController, public ortak: Ortak, public bllOrtak: BllOrtak, public viewCtrl: ViewController, public navParams: NavParams) {
    if (navParams.get("vwCari") != null) {
      this.vwCari = navParams.get("vwCari");

      var data = new FormData();
      data.append("cari_id", this.vwCari.ID);
    

      this.bllOrtak.islem(data, "CariGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.cari = Sonuc.SonucObject;
        

        this.KasaHareket.CardRef = this.cari.ID;
        this.CariHareket.CariKartID = this.cari.ID;
     
        

      }
      )
    }
    this.aktifKullanici = this.ortak.storagePersonelGetir.Name
  }

  ionViewDidLoad() {
   this.kasagetir();
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  boslukKontrol() {
    var mesaj = "";
    if (this.KasaHareket.Tutar == null || this.KasaHareket.Tutar == "") {
      mesaj = mesaj + "Lütfen cari adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
    
    this.CariHareket.Tutar = this.KasaHareket.Tutar;
    this.CariHareket.Text = this.KasaHareket.Text;
    this.CariHareket.SlsMan=this.aktifKullanici;
    this.KasaHareket.SlsMan=this.aktifKullanici;
    formData.append("CariTah_json", JSON.stringify(this.CariHareket));
    formData.append("Kasa_json", JSON.stringify(this.KasaHareket));



    this.bllOrtak.islem(formData, "CariTahsilat", "", false).then(a => {
      var sonuc = <any>a;
    
      if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
      this.kapat();
      if(sonuc.Sonuc==99)
      {

      }

    })


  }
  kasagetir(){
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "KasaListesi", "", false).then(a => {
     
      var sonuc = <any>a;
      this.kasaListesi = sonuc.SonucObject;
     
  
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/CariIslemleri/cari-tahsilat/cari-tahsilat.ts